import { useState } from 'react';

interface FaqItem {
  q: string;
  a: string;
}

interface FaqSectionProps {
  title: string;
  subtitle: string;
  questions: FaqItem[];
}

export default function FaqSection({ title, subtitle, questions }: FaqSectionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            {title}
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            {subtitle}
          </p>
        </div>

        <div className="space-y-3">
          {questions.map((item, index) => (
            <div
              key={index}
              className="rounded-lg border border-background-200 bg-background-50 overflow-hidden transition-all duration-200"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className="font-medium text-foreground-800 text-sm md:text-base pr-4">
                  {item.q}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center rounded-full transition-all duration-300 flex-shrink-0 ${
                  openIndex === index ? 'bg-primary-100 text-primary-600 rotate-180' : 'bg-background-200 text-foreground-500'
                }`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}